/* eslint-disable no-debugger */
import type { Effect, Reducer } from 'umi';

import { getUser, getStaff, getKnowledgeProduct } from '@/services/user';

export type CurrentUser = {
  avatar?: string;
  name?: string;
  title?: string;
  group?: string;
  signature?: string;
  tags?: {
    key: string;
    label: string;
  }[];
  userid?: number;
  unreadCount?: number;
};

export type Staff = { name: string; userid: string };
export type KnowledgeProduct = { productName: string; existPrompt: boolean; productZhName: string; };

export type UserModelState = {
  currentUser?: CurrentUser;
  staff?: Staff[];
  productNames?: KnowledgeProduct[];
};

export type UserModelType = {
  namespace: 'user';
  state: UserModelState;
  effects: {
    fetchUser: Effect;
    getStaff: Effect;
    getKnowledgeProduct: Effect;
  };
  reducers: {
    saveCurrentUser: Reducer<UserModelState>;
    changeNotifyCount: Reducer<UserModelState>;
    save: Reducer<UserModelState>;
  };
};

const UserModel: UserModelType = {
  namespace: 'user',

  state: {
    currentUser: {},
    staff: [],
    productNames: [],
  },

  effects: {
    *fetchUser(_, { call, put }) {
      const { resp } = yield call(getUser);
      yield put({
        type: 'saveCurrentUser',
        payload: resp.data,
      });
    },
    *getStaff(_, { call, put }) { // 编辑)
      const { resp } = yield call(getStaff);

      if (resp.code !== 0) return;

      yield put({ type: 'save', payload: { staff: resp.data.list } });
    },
    /** @description 获取知识库产品信息 */
    *getKnowledgeProduct(_, { call, put }) {
      const { resp } = yield call(getKnowledgeProduct);
      if (resp.code !== 0) return;
      yield put({ type: 'save', payload: { productNames: resp.data.list } });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: {
          avatar: action.payload.avatar ?? '',
          name: action.payload.name ?? '',
          userid: action.payload.userid ?? '',
        },
      };
    },
    changeNotifyCount(
      state = {
        currentUser: {},
      },
      action,
    ) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload.totalCount,
          unreadCount: action.payload.unreadCount,
        },
      };
    },
  },
};

export default UserModel;
